module.exports = __webpack_public_path__ + "static/logo_h180-2fcaee70a2695fa67a4d4c488eeccb82.png";